import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  box: {
    flexBasis: 'calc(50% - 20px)',
    maxWidth: 'calc(50% - 20px)',
    marginRight: 20,
    marginBottom: 20,
    padding: '15px 25px',
    boxShadow: '0px 5px 8px rgba(112, 136, 210, .34)',
    '&:last-child': {
      marginRight: 0,
      marginBottom: 0,
    },
    [theme.breakpoints.between('sm', 'md')]: {
      flexBasis: 'calc(70% - 20px)',
      maxWidth: 'calc(70% - 20px)',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      flexBasis: '100%',
      marginRight: 0,
    },
    [theme.breakpoints.down('xs')]: {
      padding: 15,
    },
  },
  reservationTitle: {
    margin: 0,
    marginBottom: 15,
    fontSize: 17,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  flex: {
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
    },
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flex: 1,
  },
  imgWrapper: {
    width: 210,
    height: 150,
    marginRight: 30,
    [theme.breakpoints.down('xs')]: {
      marginTop: 20,
    },
  },
  img: {
    display: 'block',
    width: '100%',
    height: '100%',
  },
  price: {
    display: 'block',
    marginBottom: 10,
    fontSize: 15,
    color: '#30344B',
  },
  description: {
    marginBottom: 10,
    display: 'block',
    fontSize: 14,
    color: '#30344B',
    opacity: 0.7,
  },
  button: {
    alignSelf: 'flex-end',
    minWidth: 'auto',
    padding: '5px 15px',
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    fontWeight: 600,
    background: theme.custom.lightBlue,
    borderRadius: 29,
    color: '#fff',
    textTransform: 'uppercase',
    [theme.breakpoints.down('xs')]: {
      alignSelf: 'flex-start',
    },
  },
}));
